// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1vLjt","dragIcon":"SortableItem_dragIcon__30B8U","disabled":"SortableItem_disabled__2L7dM"};